import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { deleteEntity, fetchResource, loadEntities, updateEntity } from 'helpers/utilHelpers';
import {
  ADD_PROJECT_FAVORITE,
  ARCHIVE_SERVICE_MAP,
  CONNECT_PROJECT_WEBMASTER,
  CONNECT_PROJECT_GOOGLE_SEARCH,
  SELECT_PROJECT_GOOGLE_SEARCH,
  CREATE_TEAM_MAP,
  DELETE_PROJECT,
  DELETE_PROJECT_FAVORITE,
  DELETE_SERVICE_MAP,
  DELETE_TEAM_MAP,
  LOAD_DRAWER_PROJECTS,
  LOAD_PROJECT_BY_ID,
  LOAD_PROJECT_FILE_LIST,
  LOAD_PROJECTS,
  LOAD_PROJECTS_DRIVE_FOLDERS,
  LOAD_PROJECTS_FAVORITE_MAP,
  LOAD_PROJECTS_SERVICES_MAP,
  LOAD_PROJECT_SERVICE_HISTORY,
  UPDATE_PROJECT_SERVICE_HISTORY,
  SYNC_PROJECT_DRIVE,
  UPDATE_PROJECT,
  UPDATE_PROJECT_DESCRIPTION,
  UPDATE_PROJECT_STATUS,
  UPDATE_SERVICE_MAP,
  UPDATE_PROJECT_MONITORING_SETTINGS,
  RUN_PROJECT_MONITORING,
  LOAD_PROJECTS_IMPORTANT_PAGES,
  UPDATE_PROJECTS_IMPORTANT_PAGE,
  DELETE_PROJECTS_IMPORTANT_PAGE,
  UNSET_PROJECT_INTEGRATION,
  BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE,
} from 'constants/ActionTypes';
import { hideLoader, toggleAppError } from 'actions/settingActions';

function* fetchConnectProjectWebmaster(action) {
  const { resource, queryParams } = action.payload;

  try {
    yield call(() => fetchResource(resource, 'POST', null, null, queryParams));

    if (action.payload.hideLoader) {
      yield put(hideLoader());
    }
  } catch (response) {
    if (response) {
      const data = yield response.json();

      if (response.status) {
        yield put(toggleAppError(response.status, data));
      }
    }

    yield put(hideLoader());
  }
}

function* loadProjects() {
  yield takeEvery(LOAD_PROJECTS, loadEntities);
}

function* loadProjectFileList() {
  yield takeEvery(LOAD_PROJECT_FILE_LIST, loadEntities);
}

function* loadProjectsServicesMap() {
  yield takeEvery(LOAD_PROJECTS_SERVICES_MAP, loadEntities);
}

function* loadProjectById() {
  yield takeEvery(LOAD_PROJECT_BY_ID, loadEntities);
}

function* loadProjectsImportantPages() {
  yield takeEvery(LOAD_PROJECTS_IMPORTANT_PAGES, loadEntities);
}

function* loadDrawerProjects() {
  yield takeEvery(LOAD_DRAWER_PROJECTS, loadEntities);
}

function* updateProject() {
  yield takeEvery(UPDATE_PROJECT, updateEntity);
}

function* unsetProjectIntegration() {
  yield takeEvery(UNSET_PROJECT_INTEGRATION, updateEntity);
}

function* updateProjectMonitoringSettings() {
  yield takeEvery(UPDATE_PROJECT_MONITORING_SETTINGS, updateEntity);
}

function* archiveServiceMap() {
  yield takeEvery(ARCHIVE_SERVICE_MAP, updateEntity);
}

function* addProjectFavorite() {
  yield takeEvery(ADD_PROJECT_FAVORITE, updateEntity);
}

function* deleteProjectFavorite() {
  yield takeEvery(DELETE_PROJECT_FAVORITE, deleteEntity);
}

function* updateServiceMap() {
  yield takeEvery(UPDATE_SERVICE_MAP, updateEntity);
}

function* updateProjectsImportantPages() {
  yield takeEvery(UPDATE_PROJECTS_IMPORTANT_PAGE, updateEntity);
}

function* batchUpdateProjectsImportantPages() {
  yield takeEvery(BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE, updateEntity);
}

function* deleteServiceMap() {
  yield takeEvery(DELETE_SERVICE_MAP, deleteEntity);
}

function* updateProjectStatus() {
  yield takeEvery(UPDATE_PROJECT_STATUS, updateEntity);
}

function* updateProjectDescription() {
  yield takeEvery(UPDATE_PROJECT_DESCRIPTION, updateEntity);
}

function* createTeamMap() {
  yield takeEvery(CREATE_TEAM_MAP, updateEntity);
}

function* deleteTeamMap() {
  yield takeEvery(DELETE_TEAM_MAP, deleteEntity);
}

function* connectProjectWebmaster() {
  yield takeEvery(CONNECT_PROJECT_WEBMASTER, fetchConnectProjectWebmaster);
}

function* connectProjectGoogleSearch() {
  yield takeEvery(CONNECT_PROJECT_GOOGLE_SEARCH, updateEntity);
}

function* selectProjectGoogleSearch() {
  yield takeEvery(SELECT_PROJECT_GOOGLE_SEARCH, updateEntity);
}

function* deleteProject() {
  yield takeEvery(DELETE_PROJECT, deleteEntity);
}

function* loadFavoriteMap() {
  yield takeEvery(LOAD_PROJECTS_FAVORITE_MAP, loadEntities);
}

function* loadProjectsDriveFolders() {
  yield takeEvery(LOAD_PROJECTS_DRIVE_FOLDERS, loadEntities);
}

function* syncProjectDrive() {
  yield takeEvery(SYNC_PROJECT_DRIVE, loadEntities);
}

function* runProjectMonitoring() {
  yield takeEvery(RUN_PROJECT_MONITORING, loadEntities);
}

function* deleteProjectsImportantPage() {
  yield takeEvery(DELETE_PROJECTS_IMPORTANT_PAGE, deleteEntity);
}

function* loadProjectServiceHistory() {
  yield takeEvery(LOAD_PROJECT_SERVICE_HISTORY, loadEntities);
}

function* updateProjectServiceHistory() {
  yield takeEvery(UPDATE_PROJECT_SERVICE_HISTORY, updateEntity);
}

export default function* rootSaga() {
  yield all([
    fork(deleteProject),
    fork(createTeamMap),
    fork(deleteTeamMap),
    fork(updateProjectDescription),
    fork(updateProject),
    fork(updateServiceMap),
    fork(deleteServiceMap),
    fork(updateProjectStatus),
    fork(loadProjects),
    fork(loadProjectsServicesMap),
    fork(loadProjectById),
    fork(connectProjectWebmaster),
    fork(connectProjectGoogleSearch),
    fork(selectProjectGoogleSearch),
    fork(loadDrawerProjects),
    fork(addProjectFavorite),
    fork(deleteProjectFavorite),
    fork(loadFavoriteMap),
    fork(archiveServiceMap),
    fork(loadProjectFileList),
    fork(loadProjectsDriveFolders),
    fork(syncProjectDrive),
    fork(updateProjectMonitoringSettings),
    fork(runProjectMonitoring),
    fork(loadProjectsImportantPages),
    fork(updateProjectsImportantPages),
    fork(deleteProjectsImportantPage),
    fork(unsetProjectIntegration),
    fork(batchUpdateProjectsImportantPages),
    fork(loadProjectServiceHistory),
    fork(updateProjectServiceHistory),
  ]);
}
